import './GridRowInnerBox.css';
import { GridRowInnerBoxTitle } from './../GridRowInnerBoxTitle';
import { ImportantButton } from './../ImportantButton';

const GridRowInnerBox = ({listItems, title, buttonText, onButtonClick}) => {
    return(
        <div className ="col-12 col-md-6 col-lg-4 mb-4 lavender-info-box">
            <div  className="d-flex flex-column justify-content-between p-4 inner-box">
                <div className="text-left">
                    <GridRowInnerBoxTitle title={title}/>
                    <ul>
                        {listItems.map((item, index) => (
                            <li key={index}>{item}</li>
                        ))}
                    </ul>
                    {buttonText && (
                        <ImportantButton buttonText={buttonText} onClick={onButtonClick}/>
                    )}
                </div>
            </div>
        </div>
    )
}

export { GridRowInnerBox }